import React from 'react';
import "./ArchItem.css";
import GitHubIcon from '@material-ui/icons/GitHub';


function ArchItem({year, title, techStack}) {
    return (
        <div className="archItem">
            <h5 className="year">{year}</h5>
            <h5 className="title">{title}</h5>
            <h5 className="techStack">{techStack}</h5>
            <h5 className="link"><a><GitHubIcon className="link-icon" /></a></h5>
        </div>
    )
}

export default ArchItem
